import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export default class extends Route {
  @service contentfulClient!: ContentfulClientService

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const catchUpGuides = await this.contentfulClient.getSummerGuides({ subscriptionType })
    return {
      catchUpGuides,
      subscriptionType,
    }
  }
}
